import {ConfigureSidebarModes} from "../../enums/configureSidebarModes";
import BookmarkFolder from "../../models/bookmarkFolder";
import BookmarkLink from "../../models/bookmarkLink";
import BookmarkMenu from "../../models/bookmarkMenu";
import routerSelectedMixinFactory from "../../../../common/mixins/routerSelectedMixinFactory";
import QuickLinkFolder from "../../../organization_management/models/quickLinkFolder";
import QuickLink from "../../../organization_management/models/quickLink";

export default function () {
  return {
    namespaced: true,
    state: {
      interfaceMode: ConfigureSidebarModes.showFolder,
      selectedFolder: null,
      selectedLink: null,
    },
    mutations: {
      setInterfaceMode(state, {mode, selected}: {mode: ConfigureSidebarModes, selected: BookmarkFolder | BookmarkLink | QuickLinkFolder | QuickLink}) {
        switch (mode) {
          case ConfigureSidebarModes.newFolder:
            state.selectedFolder = null;
            state.selectedLink = null;
            break;
          case ConfigureSidebarModes.showFolder:
          case ConfigureSidebarModes.editFolder:
          case ConfigureSidebarModes.newLink:
            if (selected instanceof BookmarkFolder || QuickLinkFolder) {
              state.selectedFolder = selected;
              state.selectedLink = null;
            } else { return; }
            break;
          case ConfigureSidebarModes.showLink:
          case ConfigureSidebarModes.editLink:
            if (selected instanceof BookmarkLink || QuickLink) {
              state.selectedFolder = selected.parent;
              state.selectedLink = selected;
            } else { return; }
            break;
        }

        state.interfaceMode = mode;
      },
      resetInterface(state, {bookmarkMenu}: {bookmarkMenu: BookmarkMenu}) {
        state.selectedFolder = bookmarkMenu.sortedBookmarkFolders[0];
        state.selectedLink = null;

        state.interfaceMode = ConfigureSidebarModes.showFolder;
      }
    },
  };
}
